import type { FilesApiResponse } from '@/features/Files/types';
import type { HttpClientResponse } from '@/services/api/HttpClient';
import { HttpService } from '@/services/api/HttpService';

export class FilesHttpService extends HttpService {
  loadFiles(
    hash: string,
    tariffId: string,
  ): HttpClientResponse<FilesApiResponse> {
    return this.httpClient.get(`files/${hash}/tariff/${tariffId}`);
  }
}
